var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#595959",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#595959",
    strokeWidth: 0.64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#595959CCCCCC",
    strokeWidth: 2.432
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "03 packing box",
    id: "_03_packing_box"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.09,22.76H20.96l-4.25-5.93a2,2,0,0,0-1.62-.84H6.79A2.005,2.005,0,0,0,5.1,19.07l2.99,4.65L3.9,29.3a2,2,0,0,0,1.6,3.2H6.88L6.86,54.68a2,2,0,0,0,2,2H45.09a2.008,2.008,0,0,0,2.01-2V24.76A2.008,2.008,0,0,0,45.09,22.76ZM6.79,17.99h8.3l3.41,4.77H9.85ZM5.5,30.5l4.31-5.74H35.38L31.07,30.5ZM36.38,54.68H8.86L8.88,32.5H31.07a2,2,0,0,0,1.6-.8l3.71-4.94Zm8.71,0H38.38V24.76H45.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.39,22.76A16.958,16.958,0,0,0,45.12,7.39,16.774,16.774,0,0,0,31.9,12.03l-1.92-1.06a1,1,0,0,0-.99.01,1.014,1.014,0,0,0-.5.85l-.03,1.52c-.02.93-.05,1.86-.04,2.79,0,.58.01,1.17.02,1.76l.01.88a1.333,1.333,0,0,1,0,.2,4.29,4.29,0,0,0,.04.78,1.018,1.018,0,0,0,.46.65.958.958,0,0,0,.79.11l8.34-2.36a1,1,0,0,0,.38-1.71l-1.44-1.27a10.976,10.976,0,0,1,7.53-2.12A11.1,11.1,0,0,1,54.64,23.34a10.936,10.936,0,0,1-3.99,9.25,2.667,2.667,0,0,0-.96,1.82,2.867,2.867,0,0,0,.64,2.05l.22.25a2.769,2.769,0,0,0,2.13,1,2.714,2.714,0,0,0,1.73-.63A16.882,16.882,0,0,0,60.39,22.76ZM53.12,35.55a.749.749,0,0,1-1.04-.13l-.21-.25a.754.754,0,0,1-.18-.57.663.663,0,0,1,.24-.47,12.9,12.9,0,0,0,4.7-10.92A13.111,13.111,0,0,0,44.72,11.06c-.38-.03-.76-.04-1.14-.04a12.9,12.9,0,0,0-8.78,3.4.963.963,0,0,0-.32.75.975.975,0,0,0,.34.74l.95.84-5.33,1.5v-.39c-.01-.57-.02-1.15-.02-1.73-.01-.87.01-1.74.04-2.61l1.13.63a1,1,0,0,0,1.21-.19A14.85,14.85,0,1,1,53.12,35.55Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepackIcon);
export default __webpack_public_path__ + "static/media/repack-icon.80cf5f4194561e13e5542a11b13527a1.svg";
export { ForwardRef as ReactComponent };